module.exports = __webpack_public_path__ + "public/img/img_04.f8719f14.png";